import { Routes } from '@angular/router';
import { AuthGuard, FullAccess, SubscriptionGuard, UserExist } from './interceptor';
import { DefaultLayoutComponent } from './layout';
import { SubdomainRedirectComponent } from './components/subdomain-redirect.component';
export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: SubdomainRedirectComponent,
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home',
    },
    children: [
      // {
      //   path: 'dashboard',
      //   canActivate: [AuthGuard],
      //   loadChildren: () =>
      //     import('./views/dashboard/routes').then((m) => m.routes),
      // },
      {
        path: 'theme',
        loadChildren: () =>
          import('./views/theme/routes').then((m) => m.routes),
      },
      {
        path: 'base',
        loadChildren: () => import('./views/base/routes').then((m) => m.routes),
      },
      {
        path: 'buttons',
        loadChildren: () =>
          import('./views/buttons/routes').then((m) => m.routes),
      },
      {
        path: 'forms',
        loadChildren: () =>
          import('./views/forms/routes').then((m) => m.routes),
      },
      {
        path: 'icons',
        loadChildren: () =>
          import('./views/icons/routes').then((m) => m.routes),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./views/notifications/routes').then((m) => m.routes),
      },
      {
        path: 'widgets',
        loadChildren: () =>
          import('./views/widgets/routes').then((m) => m.routes),
      },
      {
        path: 'charts',
        loadChildren: () =>
          import('./views/charts/routes').then((m) => m.routes),
      },
      {
        path: 'pages',
        loadChildren: () =>
          import('./views/pages/routes').then((m) => m.routes),
      },
      // {
      //   path:"rest",
      //   loadChildren:()=>
      //     import('./views/pages/routes').then((m) => m.routes),
      // }
    ],
  },
  {
    path: '404',
    loadComponent: () =>
      import('./views/pages/page404/page404.component').then(
        (m) => m.Page404Component
      ),
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    loadComponent: () =>
      import('./views/pages/page500/page500.component').then(
        (m) => m.Page500Component
      ),
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'login',
    canActivate: [UserExist],
    loadComponent: () =>
      import('./views/pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
    data: {
      title: 'Login Page',
    },
  },
  {
    path: 'register',
    canActivate: [UserExist],
    loadComponent: () =>
      import('./views/pages/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    data: {
      title: 'Register Page',
    },
  },
  {
    path: 'landing-page',
    canActivate: [UserExist],
    loadComponent: () => import('./views/pages/landing-page/landing-page.component').then(m => m.LandingPageComponent),
    data: {
      title: 'Landing Page'
    },
  },

  {
    path: 'home',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/home/home.component').then((m) => m.HomeComponent),
    data: {
      title: 'Home',
    },
  },
  {
    path: 'baby-predictor',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/baby-predictor/baby-predictor.component').then(
        (m) => m.BabyPredictorComponent
      ),
    data: {
      title: 'Baby Predictor',
    },
  },
  {
    path: 'data-storage',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/data-storage/data-storage.component').then(
        (m) => m.DataStorageComponent
      ),
    data: {
      title: 'Customer Management',
    },
  },
  {
    path: 'scheduling',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/scheduling/scheduling-calendar.component').then(
        (m) => m.SchedulingCalendarComponent
      ),
    data: {
      title: 'Scheduling',
    },
  },
  {
    path: 'payments',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/scheduling/payment-history.component').then(
        (m) => m.PaymentHistoryComponent
      ),
    data: {
      title: 'Payments',
    },
  },
    {
    path: 'reviews',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/google-reviews/google-reviews.component').then(
        (m) => m.GoogleReviewsComponent
      ),
    data: {
      title: 'Google Reviews',
    },
  },
  { path: 'budgeting', canActivate: [AuthGuard, SubscriptionGuard], loadComponent: () => import('./views/pages/budgeting/budgeting.component').then((m) => m.BudgetingComponent) },
  {
    path: 'advisor',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/business-advisor/business-advisor.component').then(
        (m) => m.BusinessAdvisorComponent
      ),
    data: {
      title: 'Business Advisor',
    },
  },
  {
    path: 'scheduling/settings',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/scheduling/scheduling-settings.component').then(
        (m) => m.SchedulingSettingsComponent
      ),
    data: {
      title: 'Scheduling Settings',
    },
  },
  {
    path: 'booking/appointment/:token',
    loadComponent: () =>
      import('./views/pages/booking/booking.component').then(
        (m) => m.BookingComponent
      ),
    data: {
      title: 'Your Appointment',
    },
  },
  {
    path: 'booking/:clinicSlug/success',
    loadComponent: () =>
      import('./views/pages/booking/booking.component').then(
        (m) => m.BookingComponent
      ),
    data: {
      title: 'Booking Confirmed',
    },
  },
  {
    path: 'booking/:clinicSlug/cancel',
    loadComponent: () =>
      import('./views/pages/booking/booking.component').then(
        (m) => m.BookingComponent
      ),
    data: {
      title: 'Payment Cancelled',
    },
  },
  {
    path: 'booking/:clinicSlug',
    loadComponent: () =>
      import('./views/pages/booking/booking.component').then(
        (m) => m.BookingComponent
      ),
    data: {
      title: 'Book Appointment',
    },
  },
  {
    path: 'billing',
    canActivate: [AuthGuard,FullAccess],
    loadComponent: () =>
      import('./views/pages/billing/billing.component').then(
        (m) => m.BillingComponent
      ),
    data: {
      title: 'Billing',
    },
  },
  {
    path:"reset",
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./views/pages/changepassword/changepassword.component').then(
        (m) => m.ChangepasswordComponent
      ),
    data: {
      title: 'Reset',
    },

  },
  {
    path: 'support/create',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./views/pages/support/support-create.component').then((m) => m.CreateSupportComponent),
    data: { title: 'Ticket' },
  },
  {
    path: 'support/:id',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./views/pages/support/support-view.component').then((m) => m.SupportViewComponent),
    data: { title: 'Ticket' },
  },
  {
    path: 'support',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./views/pages/support/support.component').then(
        (m) => m.SupportComponent
      ),
    data: {
      title: 'Help & Support',
    },
  },
  {
    path: 'faq',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./views/pages/faq/faq.component').then((m) => m.FaqComponent),
    data: {
      title: 'FAQ ',
    },
  },
  {
    path: 'privacy',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./views/pages/privacy/privacy.component').then(
        (m) => m.PrivacyComponent
      ),
    data: {
      title: 'Privacy Policy',
    },
  },
  {
    path: 'terms',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./views/pages/terms/terms.component').then(
        (m) => m.TermsComponent
      ),
    data: {
      title: 'Terms & Conditions',
    },
  },
  {
    path: 'otp-verification',
    canActivate: [UserExist],

    loadComponent: () =>
      import('./views/pages/otp-verification/otp-verification.component').then(
        (m) => m.OtpVerificationComponent
      ),
    data: {
      title: 'Otp Verification',
    },
  },
  {
    path: 'forgetpassword',
    canActivate: [UserExist],
    loadComponent: () =>
      import('./views/pages/forgotpassword/forgotpassword.component').then(
        (m) => m.ForgotpasswordComponent
      ),
    data: {
      title: 'forgetpassword',
    },
  },
  {
    path: 'resetpassword',
    canActivate: [UserExist],
    loadComponent: () =>
      import('./views/pages/resetpassword/resetpassword.component').then(
        (m) => m.ResetpasswordComponent
      ),
    data: {
      title: 'resetpassword',
    },
  },
  {
    path: 'invoice',
    canActivate: [AuthGuard,FullAccess],
    loadComponent: () =>
      import('./views/pages/invoice/invoice.component').then(
        (m) => m.InvoiceComponent
      ),
    data: {
      title: 'invoice',
    },
  },
  {
    path: 'user-management',
    canActivate: [AuthGuard,FullAccess],
    loadComponent: () =>
      import('./views/pages/user-management/user-management.component').then((m) => m.UserManagementComponent),
    data: {
      title: 'Sub-Account Management',
    },
  },
  {
    path: 'clinic-website',
    canActivate: [AuthGuard, SubscriptionGuard],
    loadComponent: () =>
      import('./views/pages/clinic-website/clinic-website.component').then(
        (m) => m.ClinicWebsiteComponent
      ),
    data: {
      title: 'Clinic Branding',
    },
  },
  { path: '**', redirectTo: 'home' },
];
